import type { MenuDropdownItem } from '../types/menu-item'
import { isMenuLink } from './is-menu-link'

export const isNestedMenuItemActive = (item: MenuDropdownItem): boolean => {
  return item.dropdownItems.some(item =>
    isMenuLink(item) ? item.shouldRender && item.isActive(item.href) : isNestedMenuItemActive(item),
  )
}
